module.exports = __webpack_public_path__ + "static/goiania-4c4f3a5875e3dfa525bc59b36a612df4.png";